module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "contacts-picker"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "titleized"
  }, [_vm._v(_vm._s(_vm.$t('contacts.actions.add')) + ": " + _vm._s(_vm.$t('flows.actions.contactsBase')))]), _vm._m(0)]), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadData),
      expression: "loadData"
    }],
    staticClass: "modal-body no-top-padding",
    attrs: {
      "infinite-scroll-distance": "10"
    }
  }, [_c('contact-list', {
    attrs: {
      "contacts": _vm.contacts,
      "user_id": _vm.user_id,
      "view_mode": _vm.getViewMode(),
      "initially_selected_contact_ids": _vm.selected_contact_ids
    },
    on: {
      "contact-selected": _vm.updateContactSelection,
      "filter": _vm.filter
    }
  }), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.fetching
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.next_page),
      expression: "!next_page"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v(_vm._s(_vm.$t('groups.feedback.noMoreResults')))])], 1)], 1), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "btn btn-gray",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('div', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "select-contacts",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.selectContacts
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.confirm')))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ad60b824!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/contacts/picker.vue
// module id = 1203
// module chunks = 1